import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable} from 'rxjs'
import {ApiService} from './api.service'

export interface IArticle{
  url: string
  title: string,
  category: string,
  excerpt: string,
  publishDate: Date,
  authorId: string,
  related: any[],
  type: string,
  body: any,
  thumbnail: any,
  headerImage: any,
  headerVideo?: any,
  pdf?: any
}

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  articlesUrls: string[] = ['a', 'b']
  private _articles = new BehaviorSubject([{url: 'empty'}])
  private _articleContent = new BehaviorSubject({text: 'How can we help you?', isQuestion: false, type: 'Feedback'})
  private staticArticles: any[] = [{}]
  articles = this._articles.asObservable()
  articleContent = this._articleContent.asObservable()

  constructor(private api: ApiService) {
    this.api.getArticles().subscribe(res => {
      const a = this.formatArticles(res?.data[0]?.items)
      this.changeArticles(a)
      this.articlesUrls = a.map(v => v.url)
    }, (error: any) => {
      console.error(error)
    })
  }
  changeArticleContent(articleC: any) {
    this._articleContent.next(articleC)
  }
  changeArticles(articles: any[]){
    this._articles.next(articles)
  }

  getArticleData(url: string){
    const indexOfUrl = this.articlesUrls.indexOf(url)
    if (indexOfUrl !== -1){
      this.changeArticleContent(this.staticArticles[indexOfUrl])
      return this.articleContent
    }
    else{
      setTimeout(() => {
        this.changeArticleContent(this.staticArticles[indexOfUrl])
        return this.articleContent
      }, 2000)
    }


  }
  formatArticles(articles: any[]){
    const formatArticles: IArticle[] = []
    for (const article of articles){
        const a: IArticle = {
          url: '',
          title: '',
          category: '',
          excerpt: '',
          publishDate: new Date(),
          authorId: '',
          related: [],
          type: '',
          body: {},
          thumbnail: {},
          headerImage: {},
          headerVideo: {},
        }
        a.title = article.title
        a.url = a.title.toLowerCase().replace(/[\.\,\!\?]/g, '').replace(/\s/g, '-')
        a.category = article.category
        a.excerpt = article.excerpt
        a.publishDate = article.publishedOn
        a.related = article.relatedItems
        a.authorId = article.profileId
        a.type = article.type
        const articleContents = article.contents.map(v => {
          return [v.usage, v]
        })
        const o = Object.fromEntries(articleContents)
        if (o.body){
          a.body = o.body
        }
        if (o['header-image']){
          a.headerImage = o['header-image']
        }
        if (o['header-video']){
          a.headerVideo = o['header-video']
        }
        if (o['thumbnail-image']){
          a.thumbnail = o['thumbnail-image']
        }
        formatArticles.push(a)
      }
    return formatArticles
  }
}

